import { useParams } from 'react-router'
import { useProducts } from '../context/ProductsContext'
import TopBanner from '../components/ProductId/TopBanner'
import ProductDetailed from '../components/ProductId/DetailedProducts'

const ProductDetails = () => {
  const { id } = useParams()
  const { products } = useProducts()
  const product = products.find((p) => String(p.id) === id)

  return (
    <>
      <TopBanner title={product?.title} />
      <ProductDetailed />
    </>
  )
}

export default ProductDetails
